import List from './List';
import Show from './Show';
import Edit from './Edit';

export default {
    list: List,
    show: Show,
    edit: Edit
};
